




























































import { mapActions } from 'vuex';

import Proxyable from '@/mixins/proxyable';

import { ALForm } from '@/common/component.types';

import { IInventoryAdvancePayment } from '@/models';
import { ErrorManager } from '@/models/error';
import { IInventoryAdvancePaymentOwnerMultipleUpdateActionPayload } from '@/store/inventory-advance-payment';

import ConfirmationDialog from '../common/ConfirmationDialog.vue';

import mixins from '@/utils/mixins';

const baseMixins = mixins(Proxyable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'InventoryAdvancePaymentBulkUpdateOwnerDialog',

    components: {
      ConfirmationDialog
    },

    props: {
      inventoryAdvancePayments: {
        type: Array as () => IInventoryAdvancePayment[],
        required: true
      },

      disabled: Boolean
    },

    data() {
      return {
        bulkUpdateFormValid: false,

        loading: false,
        errorMessage: '',
        detailErrorMessage: '',

        owner: null as number | null,

        ownerRules: [(v: string) => !!v || 'An owner is required']
      };
    },

    watch: {
      internalValue(value: boolean) {
        if (!value) {
          this.$emit('close');
        }
      }
    },

    methods: {
      ...mapActions({
        updateMultipleInventoryAdvancePaymentOwner:
          'inventoryAdvancePayment/updateMultipleInventoryAdvancePaymentOwner'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      clearAllErrors() {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.resetFormValidation();
      },

      close() {
        this.internalValue = false;
      },

      setInventoryAdvancePaymentsOwner(owner: number) {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;

          const inventoryAdvancePaymentIdList: number[] = this.inventoryAdvancePayments.map(
            ({ id }) => id!
          );

          const payload: IInventoryAdvancePaymentOwnerMultipleUpdateActionPayload = {
            owner: owner,
            requisitions: inventoryAdvancePaymentIdList
          };

          this.updateMultipleInventoryAdvancePaymentOwner(payload)
            .then(() => {
              this.owner = null;
              this.$emit('updated');
              this.close();
            })
            .catch(error => {
              if (error.response) {
                if (error.response.data.detail) {
                  this.detailErrorMessage = error.response.data.detail;
                }
              }

              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }
  });
